import React, { useEffect, useState } from 'react'
import useAuthStore from '../../store/auth';
import AuthLayout from '../../layouts/AuthLayout';
import SelectInputField, { FileInput, InputField } from '../../components/Input';
import religions from '../../utils/religions.json';
import { contactInfoValidation, personalInfoValidation, vocationInfoValidation } from '../../requests/accountSetup';
import SuccessStatus, { ErrorStatus } from '../../components/FormStatus';
import useStore from  '../../store/index';
import { accountSetup } from '../../adapters/profle';
import { refresh } from '../../adapters/authentication';
import { useNavigate } from 'react-router-dom';


export default function Setup() {

  const [ formState, setFormState ] = useState({
    firstname: '',
    lastname: '',
    othername: '',
    country: '',
    state: '',
    phone: '',
    dateOfBirth: '',
    education: '',
    occupation: '',
    religion: '',
    passport: '',
    signature: '',
    averageIncome: '',
    agree: false
  });
  const [loading, setLoading ] = useState(false);

  const setAuth = useAuthStore((state) => state.setAuth);
  const navigate = useNavigate();
  const authToken = useAuthStore((state) => state.token);
  const [errors, setErrors ] = useState([]);
  const countries = useStore((state) => state.countries);


  const [formStep, setFormStep] = useState(1);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [states, setStates ] = useState([]);



  const handleInputChamge = (value, inputName) => {
    formState[inputName] = value;
    setFormState(formState);
  }

 
  const goBack = async () => {
    if(formStep > 1){
      setFormStep(formStep -1);
    }
  }

  useEffect(() => {
    let countriesObject = Object.values(countries);
    let countryStates = [];
    let findCountryIndex = countriesObject.findIndex((cj) => cj.name === formState.country)
    if(findCountryIndex){
      countryStates = countriesObject[findCountryIndex]
      if (countryStates && countryStates['states']){
        let filteredStates = countryStates['states'].map((st) => st.name)
        setStates(filteredStates)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formState.country])
  
  const goForward = async () => {
    if(formStep === 1 ){
      await personalInfoValidation.validate({
        firstname: formState.firstname,
        lastname: formState.lastname,
        othername: formState.othername,
        dateOfBirth: formState.dateOfBirth,
        religion: formState.religion,
      }).then(() => {
        setFormStep(formStep+ 1);
      }).catch((err) => {
        setErrors(err.errors);
      })
    }else if(formStep === 2) {
      await vocationInfoValidation.validate({
        education: formState.education,
        occupation: formState.occupation,
        employmentStatus : formState.employmentStatus,
        averageIncome: formState.averageIncome,
      }).then(() => {

        const countryState = Object.values(countries);  
        let countryNames = [];      
        for(const country of countryState){
          if (country.name){
            countryNames.push(country.name)
          }
        }
        setFilteredCountries(countryNames)
        setFormStep(formStep+ 1);
      }).catch((err) => {
        setErrors(err.errors);
      })
    }else if(formStep === 3){
      await contactInfoValidation.validate({
        phone: formState.phone,
        country: formState.country,
        state: formState.state,
      }).then(() => {
        setFormStep(formStep + 1);
      }).catch((err) => {
        setErrors(err.errors);
      })
    }else if(formStep === 4){
      if(formState.signature === ''){
        alert('Hello')
        setErrors(['Signature is required'])
        return ;
      }

      if(!formState.agree){
        setErrors(['You have to agree to our terms and conditions'])
        return;
      }

      if (formState.passport === '') {
        setErrors(['Passport is required'])
        return;
      }

      submitForm();
    }

  }


  const handleFileInput = (e, name) => {
    if(e.target.files){
      formState[name] = e.target.files[0];
      setFormState(formState);
    }
    
  };
  const [showSuccessStatus, setShowSuccessStatus ] = useState(false)

  
  // const user = useAuthStore((state) => state.user);

  async function submitForm () {
    if(loading) return
    setLoading(true);
    const formData = new FormData();
    const dataKeys = Object.keys(formState);
    
    for await (let key of dataKeys) {
      formData.append(key, formState[key]);
    }

    try {
      // console.log(authToken);
      await accountSetup(formData).then((res) => {
        if (res.status === 200) {
          refresh(authToken).then((res) => {
            if (res.status === 200) {
              setErrors([]);
              setAuth(res.data)
            }
          })
          setShowSuccessStatus(true);
        }
      });
      setLoading(false);
      return navigate("/account/dashboard", { replace: true })
    } catch (e) {
      setErrors(['Fialed to complete Setup'])
      console.log(e);
      setLoading(false);
    }
  }

  return (
    <AuthLayout title="Setup Account">
      
      <h4 className="text-lg mb-3 mx-3"> {formStep === 1 ? 'Personal' : (formStep === 2) ? 'Vocational' : (formStep === 3) ? 'Contact' : 'Finish Setup'} {formStep !== 4 && 'Information'}</h4>
  
      <ErrorStatus errors={errors} />
      <SuccessStatus showStatus={showSuccessStatus} message="Setup Completed successfully" />

      <form onSubmit={(e) => {
        e.preventDefault();
        goForward();
      }}>
          {formStep === 1 && <div className="mt-5 animate__animated animate__fadeIn">
            <InputField isRequired={true} type="text" placeholder="First name" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'firstname')
            }} defaultValue={formState.firstname} name="firstname" id="firstname" label="First name" />

            <InputField isRequired={true} type="text" placeholder="Last name" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'lastname')
            }} defaultValue={formState.lastname} name="lastname" id="lastname" label="Last name" />
          

            <InputField isRequired={false} type="text" placeholder="Other name" onChange={(e) => {
                setErrors([]);
                handleInputChamge(e.target.value, 'othername')
              }} defaultValue={formState.othername} name="othername" id="othername" label="Other name" />

            <InputField isRequired={true} type="date" placeholder="Date of Birth" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'dateOfBirth')
            }} defaultValue={formState.dateOfBirth} name="dateOfBirth" id="dateOfBirth" label="Date of Birth" />

            <SelectInputField isRequired={true} placeholder="Religion" onChange={(e) => {
              setErrors([]);
            handleInputChamge(e.target.value, 'religion')
            }} name="religion" defaultValue={formState.religion} id="religion" label="Religion" options={religions} />
          </div>}

          {formStep === 2 && <div className="mt-5 mb-3 animate__animated animate__fadeIn">
            <SelectInputField isRequired={true} placeholder="Education Status" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'education')
            }} name="education" defaultValue={formState.education} id="education" label="Education" options={["O'Level", "Bachelor's Degree", "Post Graduate"]} />

            <InputField isRequired={false} type="text" placeholder="Occupation" onChange={(e) => {
                setErrors([]);
                handleInputChamge(e.target.value, 'occupation')
            }} defaultValue={formState.occupation} name="occupation" id="occupation" label="Occupation" />

            <SelectInputField isRequired={true} placeholder="Employment Status" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'employmentStatus')
            }} name="employmentStatus" defaultValue={formState.employmentStatus} id="employmentStatus" label="Employment Status" options={["Employed", "Un-Employed", "Self-Employed"]} />

            <InputField isRequired={true} type="text" placeholder="$0.00" onChange={(e) => {
                setErrors([]);
                handleInputChamge(e.target.value, 'averageIncome')
            }} defaultValue={formState.averageIncome} name="averageIncome" id="averageIncome" label="Average Income" />
          </div>}

          {formStep === 3 && <div className="mt-5 mb-3 animate__animated animate__fadeIn">
            <SelectInputField isRequired={true} placeholder="Country" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'country')
            }} name="country" defaultValue={formState.country} id="country" label="Country" options={filteredCountries} />


            <SelectInputField isRequired={true} placeholder="State" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'state')
            }} name="state" id="state" defaultValue={formState.state} label="State/Province" options={states.length > 0 ? states : []} />

            <InputField isRequired={true} type="text" placeholder="+1 0000-0000" onChange={(e) => {
              setErrors([]);
              handleInputChamge(e.target.value, 'phone')
            }} defaultValue="" name="phone" id="phone" label="Phone no" />
          </div>}

          {formStep === 4 && <div className="mt-5 mb-3 animate__animated animate__fadeIn">
            <div className="mt-3 px-3 mb-6">
            {Object.keys(formState).map((fs) => {
              if(fs !== 'signature' && fs !== 'passport' && formState[fs] !== '' && fs !== 'agree'){
                return <div key={fs} className="flex mb-3 py-1 text-sm items-center justify-between w-full">
                  <span className="capitalize font-semibold ">{fs}</span>
                  <span>{formState[fs]}</span>
                </div>
              }
            })}
            </div>
            <FileInput name='signature' value={formState.signature} isRequired={true} label="signature" id="signature" onChange={(e) => {
              handleFileInput(e, 'signature')
            }} fileType="image/*" />
            <FileInput name='passport' value={formState.passport} isRequired={true} label="Passport Picture" id="passport" onChange={(e) => {
              handleFileInput(e, 'passport')
            }} fileType="image/*" />

            <div className="mt-4 px-3">
              <label htmlFor="terms" className="flex items-center gap-3">
                <input type="checkbox" className="h-4 w-4" name='term-of-use' onChange={(e) => {
                  handleInputChamge(e.target.checked, 'agree');
                }} />
              <span className="text-xs font-semibold text-gray-800">I agree to the <a href="/terms" target="_blank">terms and conditions</a></span>
              </label>
            </div>
          </div>}
        <div className="mt-5 mb-4 flex justify-between items-center px-3">
          { formStep > 1 &&  <button onClick={goBack} className="py-2 px-4 rounded-lg border-2 text-xs font-semibold border-gray-400 hover:border-blue-800 transition delay-200 ease-in-out">Previous</button>}
          { formStep < 4 && <button onClick={goForward} className="py-2 px-4 rounded-lg border-2 text-xs font-semibold text-white bg-blue-800 border-blue-800 hover:bg-blue-600  hover:border-blue-600 transition delay-200 ease-in-out">Next</button>}
          { formStep === 4 && <div onClick={goForward} className="py-2 px-8 cursor-pointer rounded-lg border-2 text-xs font-semibold text-white bg-blue-800 border-blue-800 hover:bg-blue-600  hover:border-blue-600 transition delay-200 ease-in-out">{!loading ? 'Submit' : 'Submiting...'}</div>}
        </div>
      </form>

    </AuthLayout>
  )
}
